import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-white px-4 py-14" data-id="element-108" data-mp="4wb7ejl1fhq4">
      <div className="mx-auto max-w-md" data-id="element-109" data-mp="4xcmcz56cod4">
        <div className="rounded-3xl border-2 border-emerald-200 bg-emerald-50/50 p-6 text-center" data-id="element-110" data-mp="9u3a88n80o93">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-emerald-100" data-id="element-111" data-mp="etpnuj6yo6if">
            <ShieldCheckIcon className="h-9 w-9 text-emerald-600" data-id="element-112" data-mp="jrhfrd7lvsmm" />
          </div>
          <h2 className="mt-4 font-display text-2xl font-bold text-plum" data-id="element-113" data-mp="ntm3xwfabx1v">
            Garantía Total de 7 Días
          </h2>
          <p className="mt-3 text-[15px] leading-relaxed text-plum/70" data-id="element-114" data-mp="sm5jv01g349u">
            Queremos que explores el material con tranquilidad. Si durante los primeros 7 días
            consideras que El Oráculo de las Preguntas no aporta valor a tu práctica clínica, solo
            escríbenos y te devolveremos el{' '}
            <span className="font-bold text-emerald-700" data-id="element-115" data-mp="17id2hvx7fxn0">100% de tu dinero.</span>
          </p>
          <div className="mt-5 space-y-1.5 text-sm font-medium text-plum/80" data-id="element-116" data-mp="25ti40dzy6exd">
            <p data-id="element-117" data-mp="20rsp2n9lth40">✓ Sin formularios complicados.</p>
            <p data-id="element-118" data-mp="20v6u639nk4f5">✓ Sin explicaciones innecesarias.</p>
            <p data-id="element-119" data-mp="1vusnopnp92j8">✓ Sin riesgos para ti.</p>
          </div>
        </div>
      </div>
    </section>;
}